/*
 * Modal
 *********************************** */
// var modalContent = "";
// // instanciate new modal
// var modal = new tingle.modal({
//   beforeClose: function () {
//     modal.setContent("");
//     return true; // close the modal
//   }
// });
// // data-modal属性を持つトリガーボタンを取得
// var modalTrigger = document.querySelectorAll('[data-modal]');
// if (modalTrigger.length > 0) {
//   for (let i = 0; i < modalTrigger.length; i++) {
//     var el = modalTrigger[i];
//     //イベントをバインド
//     _addModalEvent(el);
//   }
// }
// function _addModalEvent(el) {
//   el.addEventListener('click', function (event) {
//     event.preventDefault();
//     // data-modalに指定したIDの要素を取得
//     var target = el.getAttribute('data-modal');
//     // モーダルのコンテンツを取得
//     var modalContent = document.querySelector(target);
//     if (modalContent) {
//       // コンテンツをセット
//       modal.setContent(modalContent.innerHTML);
//       // モーダルオープン
//       modal.open();
//     }
//   })
// }

/*
 * Swiper
 *********************************** */
// let mySwiper = new Swiper('.swiper-container', {
//   autoplay: false,
//   loop: true,
//   slidesPerView: 1,
//   spaceBetween: 60,
//   allowTouchMove: true,

//   breakpoints: {
//     415: {
//       autoplay: false,
//       loop: true,
//       slidesPerView: 2,
//       spaceBetween: 20,
//       allowTouchMove: true,
//     },
//     769: {
//       autoplay: false,
//       loop: false,
//       slidesPerView: 3,
//       spaceBetween: 40,
//       allowTouchMove: false
//     }
//   },

//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: true,
//   },

//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

// })


/*
 * Toggle Menu
 */
// $(() => {
//   let targetClassName = $(".o-header__nav"),
//     targetBtnName = $(".a-hamburger-menu"),
//     targetClassState = "is-open",
//     targetClassFixPos = "is-fixed",
//     state = false,
//     scrollPos;

//   targetBtnName.on("click", (openSpMenu) => {
//     // メニューの展開トグル
//     $(openSpMenu.currentTarget).toggleClass(targetClassState);
//     targetClassName.toggleClass(targetClassState);

//     // メニュー展開時にメインコンテンツの位置を固定
//     if (state == false) {
//       scrollPos = $(window).scrollTop();
//       $("body")
//         .addClass(targetClassFixPos)
//         .css({ top: -scrollPos });
//       state = true;
//     } else {
//       $("body")
//         .removeClass(targetClassFixPos)
//         .css({ top: 0 });
//       window.scrollTo(0, scrollPos);
//       state = false;
//     }
//   });
// });

// // メニューを閉じる
// $('.o-nav a').on('click', function () {
//   $('.a-hamburger-menu').removeClass('is-open');
//   $('.o-header__nav').removeClass('is-open');
// });


/*
 * Smooth Scroll
 *********************************** */
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});


/**
  * .a-button-topをスクロールしてから表示させる
  */
$(function () {
  var pagetop = $('.a-button-top');
  pagetop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 750) {
      pagetop.fadeIn();
      pagetop.addClass('is-active');
    } else {
      pagetop.fadeOut();
      pagetop.removeClass('is-active');
    }
  });
  pagetop.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
});

/**
  * .o-sticky をある程度スクロールしてから表示させるスクリプト
  * 適宜書き直してください。
  */
const toVisibleItemOnScroll = (element, targetPosition) => {
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > targetPosition) {
      element.classList.remove('is-hidden');
    } else {
      element.classList.add('is-hidden');
    }
  });
};

toVisibleItemOnScroll(
  document.querySelector('.o-sticky'),
  250,
);



/**
  * .o-issue__close を表示領域に入ったらfadeinさせる
  */
$(window).scroll(function () {
  $('.o-issue__close').each(function () {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();
    if (scroll > elemPos - windowHeight + 100) {
      $(this).addClass('is-fadein');
    }
  });
});


/**
  * header 追従時の表示領域を狭くする
  */
$(window).scroll(function () {
  if ($(window).scrollTop() > 1) {
    $('.o-header__container').addClass('is-narrow');
  } else {
    $('.o-header__container').removeClass('is-narrow');
  }
});
